module.exports = __webpack_public_path__ + "images/jssc.cb82.png";